// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falEuroSign: CreateIconOptions = {
  "displayName": "FALEuroSign",
  "viewBox": "0, 0, 320, 512",
  "d": "M34.3 224c-1.5 10.5-2.3 21.1-2.3 32s.8 21.5 2.3 32L16 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l25.3 0C68.8 412.5 154.5 480 256 480l49 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-49 0c-83.6 0-154.7-53.4-181.1-128L272 320c8.8 0 16-7.2 16-16s-7.2-16-16-16L66.7 288c-1.7-10.4-2.7-21.1-2.7-32s.9-21.6 2.7-32L272 224c8.8 0 16-7.2 16-16s-7.2-16-16-16L74.9 192C101.3 117.4 172.4 64 256 64l49 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-49 0C154.5 32 68.8 99.5 41.3 192L16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l18.3 0z"
};
